import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageSelector = _resolveComponent("LanguageSelector")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('nav.home')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/cv" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('nav.cv')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_LanguageSelector, { class: "light" })
  ]))
}